<template>
    <div>
        <b-form-group label="Date of birth"
                      label-size="sm"
                      :label-cols-sm="1"
                      :description="`Set value or FDO reference. Date format is ${SERVER_DATE}`">
            <b-form-input size="sm"
                          v-model="value[0]"></b-form-input>
        </b-form-group>
        <b-form-group label="Min age"
                      label-size="sm"
                      :label-cols-sm="1">
            <b-form-input size="sm"
                          v-model.number="value[1]"
                          type="number"></b-form-input>
        </b-form-group>
        <b-form-group label="Max age"
                      label-size="sm"
                      :label-cols-sm="1">
            <b-form-input size="sm"
                          v-model.number="value[2]"
                          type="number"></b-form-input>
        </b-form-group>
    </div>
</template>

<script>
import valueCmp from "./mixins/valueCmp";
import {SERVER_DATE} from "@/commons/dateUtils";

export default {
    mixins: [valueCmp],
    computed: {
        SERVER_DATE() {
            return SERVER_DATE
        }
    }
}
</script>

<style scoped>

</style>
